/*******************************************************************************
CLEAR INPUT BOX
Resets the input box to its empty state.
*******************************************************************************/

export default function clearInputBox($input) {

    // Clear the input and remove the clear button
    $input.val('').parents('.input-wrapper').find('.input-clear').remove();
}
